import { formOptions } from "@tanstack/react-form";
import {
  defaultValues,
  deliveryOptionFormSchema,
} from "@/schemas/DeliveryForm/delivery-option.schema";

export const deliveryOptionFormOpts = formOptions({
  defaultValues: defaultValues,
  validators: {
    onChange: deliveryOptionFormSchema,
    onSubmit: deliveryOptionFormSchema,
  },
});
